
export default {
  props: {
    _class: { type: Boolean },
    disabled: { type: Boolean },
    loading: { type: Boolean },
    loadingLabel: { type: String }
  }
}
